var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilecss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bases",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dcdbdd;}.cls-2{fill:#cc4e51;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file.css") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u7F16\\u7EC4_",
    "data-name": "<\\u7F16\\u7EC4>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u7F16\\u7EC4_2",
    "data-name": "<\\u7F16\\u7EC4>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u7F16\\u7EC4_3",
    "data-name": "<\\u7F16\\u7EC4>"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5,16.76V15.24a2.36,2.36,0,0,0,.68-.11,1.44,1.44,0,0,0,.44-.23.93.93,0,0,0,.25-.32,1.33,1.33,0,0,0,.12-.35,2.62,2.62,0,0,0,0-.37q0-.22,0-.46t0-.61l0-.5q-.12-1.13-.12-1.59a2.51,2.51,0,0,1,.8-2A3.4,3.4,0,0,1,9.34,8H10V9.7H9.68a1.16,1.16,0,0,0-.94.37,1.66,1.66,0,0,0-.29,1.05,8.92,8.92,0,0,0,.1,1.15q.1,1,.1,1.38a3.64,3.64,0,0,1-.1,1,1.74,1.74,0,0,1-.33.68,1.76,1.76,0,0,1-.54.43,2.94,2.94,0,0,1-.74.25v0a2.94,2.94,0,0,1,.74.24,1.7,1.7,0,0,1,.54.43,1.74,1.74,0,0,1,.33.68,3.71,3.71,0,0,1,.1,1q0,.35-.1,1.4a8.23,8.23,0,0,0-.1,1.13,1.72,1.72,0,0,0,.28,1.07,1.15,1.15,0,0,0,.94.38H10V24H9.32q-3,0-3-2.73,0-.46.12-1.59l0-.49q0-.36,0-.6c0-.16,0-.32,0-.46a2.36,2.36,0,0,0,0-.36,1.29,1.29,0,0,0-.11-.35.92.92,0,0,0-.25-.32,1.39,1.39,0,0,0-.45-.23A2.43,2.43,0,0,0,5,16.76Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_\\u7F16\\u7EC4_4",
    "data-name": "<\\u7F16\\u7EC4>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u7F16\\u7EC4_5",
    "data-name": "<\\u7F16\\u7EC4>"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.35,16.87a1.39,1.39,0,0,0-.45.23.92.92,0,0,0-.25.32,1.29,1.29,0,0,0-.11.35,2.36,2.36,0,0,0,0,.36c0,.15,0,.31,0,.46s0,.36,0,.6l0,.49q.12,1.13.12,1.59,0,2.73-3,2.73H22V22.32h.36a1.15,1.15,0,0,0,.94-.38,1.72,1.72,0,0,0,.28-1.07,8.23,8.23,0,0,0-.1-1.13q-.1-1.05-.1-1.4a3.71,3.71,0,0,1,.1-1,1.74,1.74,0,0,1,.33-.68,1.7,1.7,0,0,1,.54-.43A2.94,2.94,0,0,1,25.1,16v0a2.94,2.94,0,0,1-.74-.25,1.76,1.76,0,0,1-.54-.43,1.74,1.74,0,0,1-.33-.68,3.64,3.64,0,0,1-.1-1q0-.38.1-1.38a8.92,8.92,0,0,0,.1-1.15,1.66,1.66,0,0,0-.29-1.05,1.16,1.16,0,0,0-.94-.37H22V8h.7a3.4,3.4,0,0,1,2.24.67,2.51,2.51,0,0,1,.8,2q0,.46-.12,1.59l0,.5q0,.37,0,.61t0,.46a2.62,2.62,0,0,0,0,.37,1.33,1.33,0,0,0,.12.35.93.93,0,0,0,.25.32,1.44,1.44,0,0,0,.44.23,2.36,2.36,0,0,0,.68.11v1.52A2.43,2.43,0,0,0,26.35,16.87Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_\\u7F16\\u7EC4_6",
    "data-name": "<\\u7F16\\u7EC4>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "_\\u8DEF\\u5F84_",
    "data-name": "<\\u8DEF\\u5F84>",
    className: "cls-2",
    cx: 16,
    cy: 16,
    r: 5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilecss);
export default __webpack_public_path__ + "static/media/file.css.07ca47bf23b07f94c207470a3f5e81e8.svg";
export { ForwardRef as ReactComponent };